import { Component, inject, input, output, Signal } from '@angular/core';
import { User } from '../user/user';
import { NgxPoettingerComponentsModule } from '@it-entwicklung/ngx-poettinger-components';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AppLink } from '@app/types/app-link.type';
import { Parameters } from '../parameters/parameters';
import { ParametersService } from '../parameters/parameters.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { globeOutline } from 'ionicons/icons';
import { UserManagerService } from '@app/managers';
import { LoginButtonDirective } from "@app/directives/login-button.directive";
import { environment } from 'environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { PoeModalService } from '@app/services/poe-modal.service';

@Component({
    selector: 'app-titlebar',
    imports: [
        NgxPoettingerComponentsModule,
        TranslateModule,
        RouterModule,
        IonIcon,
        LoginButtonDirective
    ],
    templateUrl: './titlebar.component.html',
    styleUrl: './titlebar.component.scss'
})
export class TitlebarComponent {
    viewMode = input<'kiosk' | ''>('');
    user = input<User>();
    appLinks = input<AppLink[]>();
    userMenuToggled = output<void>();
    mobileMenuToggled = output<void>();
    configuratorCountries = environment.configuratorRestrictions.map(limitation => limitation.locale);

    parametersService = inject(ParametersService);
    userManager = inject(UserManagerService);
    private readonly authService = inject(AuthService);
    private readonly modalService = inject(PoeModalService);

    protected params: Signal<Parameters | undefined> = toSignal(this.parametersService.getParametersObservable());
    protected userConfigurations = this.userManager.machineConfigurations;
    protected userMachines = this.userManager.userMachinesResource;
    constructor() {
        addIcons({ globeOutline });
    }

    onClickPoetsem(): void {
        window.open('https://www.poettinger.at/poetsem', '_blank', 'noopener,noreferrer');
        this.mobileMenuToggled.emit();
    }

    logout(): void {
        this.authService.logout({
            logoutParams: {
                returnTo: environment.logoutUrl
            }
        });
    }

    openAppPopup(appInfo: AppLink) {
        this.modalService.showAppStoreModal(
            {
                title: appInfo.name
            },
            appInfo
        );
    }
}
